/** Browser tab title for a record page (edit or dashboard view). */
export const getRecordPageTitle = (data: {
    name?: string | null;
    project_id_project?: { name?: string | null } | null;
    bundle_id_bundle?: { name?: string | null } | null;
}): string => {
    if (!data?.name) {
        return "Cloudomation";
    }
    if (data.project_id_project?.name) {
        return `${data.name} - ${data.project_id_project.name} - Cloudomation`;
    }
    if (data.bundle_id_bundle?.name) {
        return `${data.name} - ${data.bundle_id_bundle.name} - Cloudomation`;
    }
    return `${data.name} - Cloudomation`;
};
